import Storage from '../Storage.js';

Storage.setConfig("mailings", {
  section: "main",
  config: {
    method: "mailings/",
    title: "Отправления",
    objectName: "Отправление",
    search: {
      id: {
        title: "#",
        type: "text"
      },
      ids: {
        title: "Сканер",
        type: "scan",
      },
      state_id: {
        title: "Статус",
        type: "select",
        request: "mailing_states/all/"
      },
      courier_id: {
        type: "select",
        request: "couriers/all",
        title: "Курьер",
        adminGroup: true,
      },
      user_group_id: {
        title: "Группа",
        type: "select",
        request: "user_groups/"
      },
      list_ids: {
        title: "Реестры",
        type: "multi",
        request: "lists/"
      },
      created: {
        title: "Создан",
        type: "date-interval"
      },
      sender: {
        title: "Отправитель",
        type: "text"
      },
      recipient: {
        title: "Получатель",
        type: "text"
      },
      sender_address: {
        title: "Откуда",
        type: "address",
        placeholder: {
          region: "Регион",
          locality: "Населенный пункт",
          street: "Улица",
          other: "Дом, квартира ..."
        }
      },
      recipient_address: {
        title: "Куда",
        type: "address",
        placeholder: {
          region: "Регион",
          locality: "Населенный пункт",
          street: "Улица",
          other: "Дом, квартира ..."
        }
      },
      delivery_date: {
        title: "Дата",
        type: "date"
      },
    },
    export: {
      /*list_create: {
        type: "create",
        button: "Создать реестр",
        confirm: "Создать",
        placeholder: "Имя реестра",
        method: "lists/export/",
        nameParameter: "name",
        listParameter: "mailing_ids",
      },
      list_add: {
        type: "choose",
        button: "Добавить в реестр",
        confirm: "Добавить",
        placeholder: "Выберите реестр",
        method: "lists/export/",
        idParameter: "id",
        listParameter: "mailing_ids",
        optionsRequest: "lists/"
      },
      list_remove: {
        type: "choose",
        button: "Убрать из реестра",
        confirm: "Убрать",
        placeholder: "Выберите реестр",
        method: "lists/pop_mailings",
        idParameter: "id",
        listParameter: "mailing_ids",
        optionsRequest: "lists/"
      },
      status_change: {
        type: "choose",
        button: "Изменить статус",
        confirm: "Изменить",
        placeholder: "Выберите статус",
        method: "mailings/status_change/",
        idParameter: "state_id",
        listParameter: "mailing_ids",
        optionsRequest: "mailing_states/all"
      },*/
      print: {
        type: "print",
        button: "Печать выбранных",
        confirm: "Выбрать",
        placeholder: "Выберите форму",
        options: {
          e_65: "Формы Е-65, C4, C5",
          notification: "Уведомление",
          notification_with_passport: "Уведомление c паспортными данными",
          announcing: "Извещение",
          twoside_announcing: "Двустороннее извещение",
          repeat_announcing: "Вторичное извещение",
          barcode: "Штрих-код",
          c5_recipient: "С5 - Только получатель",
          for_client: "Печтаь для клиента",
        }
      },
      print_interval: {
        type: "print_interval",
        noSelect: true,
        button: "Печать интервала",
        confirm: "Выбрать",
        placeholder: "Выберите форму",
        options: {
          e_65: "Формы Е-65, C4, C5",
          notification: "Уведомление",
          notification_with_passport: "Уведомление c паспортными данными",
          announcing: "Извещение",
          twoside_announcing: "Двустороннее извещение",
          repeat_announcing: "Вторичное извещение",
          barcode: "Штрих-код",
          c5_recipient: "С5 - Только получатель",
          for_client: "Печтаь для клиента",
        }
      },
      /*malings_import: {
        type: "upload",
        noSelect: true,
        button: "Загрузить список",
        confirm: "Отправить",
        method: "mailings/import/",
        accept: ".csv, .xlsx",
        fileParameter: "file",
      },*/
      scan: {
        type: "scan",
        noSelect: true,
        button: "Сканер",
        confirm: "Отправить",
        method: "mailings/scan/",
        adminGroup: true,
        fields: {
          mailing_state: {
            default: {},
            type: "select",
            request: "mailing_states/all",
            title: "Статус",
          },
          delivery_date: {
            default: "",
            type: "date",
            title: "Дата",
          },
          courier: {
            default: {},
            type: "select",
            request: "couriers/all",
            title: "Курьер",
          },
          return_case: {
            default: "",
            type: "text",
            title: "Причина возврата",
            clearable: true,
            options: [
              'за истечением срока хранения, возврат заказного письма',
              'умер, возврат заказного письма',
              'не проживает, возврат заказного письма',
              'сменился собственник, возврат заказного письма',
              'дом снесен, возврат заказного письма',
              'отказ в получении, возврат заказного письма',
              'не верный адрес, возврат заказного письма',
              'временно отсутствует, возврат заказного письма',
              'организация ликвидирована, возврат заказного письма',
              'адресат не найден, возврат заказного письма',
            ],
          },
          overwrite: {
            default: false,
            type: "checkbox",
            title: "Перезаписывать",
          },
          scan: {
            default: [],
            type: "scan",
            title: "Сканер",
          },
        },
        printTitle: "Отчет",
        print_options: {
          received_report: "Отчет - Врученые",
          returned_report: "Отчет - Возврат",
        }
      },
      act_acceptance: {
        type: "act",
        act: "acceptance",
        noSelect: true,
        button: "Акт приема-передачи",
        confirm: "Сформировать",
      },
      act_return: {
        type: "act",
        act: "return",
        noSelect: true,
        button: "Акт возвратов",
        confirm: "Сформировать",
      },
      act_courier: {
        type: "act_courier",
        noSelect: true,
        button: "Акт по курьеру",
        confirm: "Сформировать",
        adminGroup: true,
      },
    },
    extra_fields: {
      parameter: "fields",
      method: "fields/current/",
      objectParameter: "mailing_id",
      //request: "inputs/optional/",
      idParameter: "field_id"
    }
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "20px"
    },
    create_time: {
      default: "",
      type: "text",
      title: "Создан",
      preset: true,
      width: false
    },
    update_time: {
      default: "",
      type: "text",
      title: "Обновлен",
      preset: true,
      width: false
    },
    deleted: {
      default: false,
      type: "none",
      title: "",
      preset: true,
      width: false
    },
    mailing_state: {
      default: {},
      type: "select",
      request: "mailing_states/all",
      title: "Статус",
      preset: false,
      width: "auto"
    },
    delivery_date: {
      default: "",
      type: "date",
      title: "Дата",
      width: false,
    },
    store_until: {
      default: "",
      type: "date",
      title: "Срок хранения",
      width: false,
    },
    courier: {
      default: {},
      type: "select",
      request: "couriers/all",
      title: "Курьер",
      preset: false,
      adminGroup: true,
      width: "auto"
    },
    sender_name: {
      default: "",
      type: "text",
      request: "templates/",
      minSearch: 2,
      template_mapping: {
        postalcode: "sender_postalcode",
        address: "sender_address",
      },
      title: "Отправитель",
      preset: false,
      width: false
    },
    sender_postalcode: {
      default: "",
      type: "text",
      //request: "inputs/primary/",
      title: "Индекс отправителя",
      preset: false,
      width: false
    },
    sender_address: {
      default: {region:"",locality:"",street:"",other:""},
      type: "address",
      //request: "inputs/address/",
      title: "Откуда",
      preset: false,
      width: false,
      placeholder: {
        region: "Регион",
        locality: "Населенный пункт",
        street: "Улица",
        other: "Дом, квартира ..."
      }
    },
    recipient_name: {
      default: "",
      type: "text",
      request: "templates/",
      minSearch: 1,
      template_mapping: {
        postalcode: "recipient_postalcode",
        address: "recipient_address",
      },
      title: "Получатель",
      preset: false,
      width: "auto"
    },
    recipient_postalcode: {
      default: "",
      type: "text",
      //request: "inputs/primary/",
      //title: "Индекс получателя",
      preset: false,
      width: false
    },
    recipient_address: {
      default: {region:"",locality:"",street:"",other:""},
      type: "address",
      //request: "inputs/address/",
      title: "Куда",
      preset: false,
      width: "auto",
      placeholder: {
        region: "Регион",
        locality: "Населенный пункт",
        street: "Улица",
        other: "Дом, квартира ..."
      }
    },
    recipient_account_number: {
      default: "",
      type: "text",
      title: "Л/С получателя",
      width: false
    },
    return_case: {
      default: "",
      type: "text",
      title: "Причина возврата",
      clearable: true,
      options: [
        'за истечением срока хранения, возврат заказного письма',
        'умер, возврат заказного письма',
        'не проживает, возврат заказного письма',
        'сменился собственник, возврат заказного письма',
        'дом снесен, возврат заказного письма',
        'отказ в получении, возврат заказного письма',
        'не верный адрес, возврат заказного письма',
        'временно отсутствует, возврат заказного письма',
        'организация ликвидирована, возврат заказного письма',
        'адресат не найден, возврат заказного письма',
      ],
      width: false
    },
    forwarding: {
      default: "",
      type: "checkbox",
      title: "Переадресация",
      width: "20px"
    },
  }
});



// WEBPACK FOOTER //
// ./src/config/mailings.js